<!-- 谈话记录 -->
<template>
  <div class="MemconForm">

    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="学生学号">
        <el-input :disabled="true" v-model="ruleForm.userID"></el-input>
      </el-form-item>

      <el-form-item label="学生姓名">
        <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
      </el-form-item>

      <el-form-item label="心理辅导员">
        <el-input :disabled="true" v-model="ruleForm.teachID"></el-input>
      </el-form-item>

      <el-form-item label="谈话时间">
        <el-date-picker :disabled="true" v-model="ruleForm.talkTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="谈话地点">
        <el-input :disabled="true" v-model="ruleForm.talkAddress"></el-input>
      </el-form-item>

      <el-form-item class="a1" label="初评危机状态">
        <span v-if="ruleForm.firstCrisisGrade =='1'"  style="color: red;">红色预警</span>
        <span v-else-if="ruleForm.firstCrisisGrade == '2'"  style="color: #ffdb00;">橙色预警</span>
        <span v-else-if="ruleForm.firstCrisisGrade == '3'"  style="color: #e6a707;">黄色预警</span>
        <span v-else-if="ruleForm.firstCrisisGrade == '4'"  style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="ruleForm.firstCrisisGrade == '5'"  style="color: #00f670;">绿色预警</span>
        <span v-else-if="ruleForm.firstCrisisGrade == '6'">绿色预警</span>

      </el-form-item>

      <el-form-item style="position: relative;" class="a1" label="心理中心建议">
        <el-checkbox-group :disabled="true" v-model="ruleForm.psychCentralSuggests">
          <el-checkbox  label="1" name="type">精神专科就医</el-checkbox>
          <el-checkbox  label="2" name="type">心理咨询</el-checkbox>
          <el-checkbox  label="3" name="type">心理危机干预</el-checkbox>
          <el-checkbox  label="4" name="type">保密突破联系监护人</el-checkbox>
          <el-checkbox  label="5" name="type">报警急救</el-checkbox>
          <el-checkbox  label="6" name="type">严密守护</el-checkbox>
          <el-checkbox  label="7" name="type">密切陪护</el-checkbox>
          <el-checkbox  label="8" name="type">重点关注</el-checkbox>
          <el-checkbox  label="9" name="type">适当关注</el-checkbox>
          <el-checkbox  label="10" name="type">正常交流</el-checkbox>
          <el-checkbox  label="11" name="type">其他</el-checkbox>
        </el-checkbox-group>

        <el-input style="position: absolute;top: 45px;left: 520px;" v-model="ruleForm.otherSuggest" placeholder="其他"></el-input>
      </el-form-item>

      <h2 style="margin-left: 20px;" >学生近况 ( <i style="color: red;">*</i> 为必填项） </h2>

      <el-form-item class="a2" label="严重情况突出表现  自杀、自伤或伤害他人倾向">
        <el-radio-group v-model="ruleForm.suicidalFlg">
          <el-radio label="1">有</el-radio>
          <el-radio label="2">无</el-radio>
          <el-radio label="3">待确定</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a3" label="关于伤害的情况">
        <el-checkbox-group v-model="ruleForm.damages">
          <el-checkbox  label="1" name="type">自杀想法</el-checkbox>
          <el-checkbox  label="2" name="type">自杀计划</el-checkbox>
          <el-checkbox  label="3" name="type">自杀未遂</el-checkbox>
          <el-checkbox  label="4" name="type">自杀实施中</el-checkbox>
          <el-checkbox  label="5" name="type">自杀姿态</el-checkbox>
          <el-checkbox  label="6" name="type">被动自杀</el-checkbox>
          <el-checkbox  label="7" name="type">自伤自残</el-checkbox>
          <el-checkbox  label="8" name="type">伤害他人</el-checkbox>
          <el-checkbox  label="9" name="type">扩大性自杀</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="发生时间">
        <el-date-picker v-model="ruleForm.suicidalDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="发生情况">
        <el-input v-model="ruleForm.suicidalDetail"></el-input>
      </el-form-item>

      <el-form-item class="a4" label="疑似重性精神障碍">
        <el-radio-group v-model="ruleForm.psychosesFlg">
          <el-radio label="1">有</el-radio>
          <el-radio label="2">无</el-radio>
          <el-radio label="3">待确定</el-radio>
        </el-radio-group>
      </el-form-item>
    
      <el-form-item class="a5" label="疑似出现">
        <el-checkbox-group v-model="ruleForm.suspectedAppears">
          <el-checkbox label="1" name="type">感知觉障碍</el-checkbox>
          <el-checkbox label="2" name="type">思维障碍</el-checkbox>
          <el-checkbox label="3" name="type">注意障碍</el-checkbox>
          <el-checkbox label="4" name="type">记忆障碍</el-checkbox>
          <el-checkbox label="5" name="type">定向力障碍</el-checkbox>
          <el-checkbox label="6" name="type">情感障碍</el-checkbox>
          <el-checkbox label="7" name="type">意志障碍</el-checkbox>
          <el-checkbox label="8" name="type">动作与行为障碍</el-checkbox>
          <el-checkbox label="9" name="type">意识障碍</el-checkbox>
          <el-checkbox label="10" name="type">自知力缺失</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="发生时间">
        <el-date-picker v-model="ruleForm.psychosesDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="发生情况">
        <el-input v-model="ruleForm.psychosesDetail"></el-input>
      </el-form-item>

      <el-form-item label="谈话时间">
        <el-date-picker v-model="ruleForm.appearDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="谈话地点">
        <el-input v-model="ruleForm.appearAddress"></el-input>
      </el-form-item>
      <el-form-item label="发生情况">
        <el-input v-model="ruleForm.appearDetail"></el-input>
      </el-form-item>

      <h2 style="margin-left: 20px;">干预工作情况</h2>

      <el-form-item class="a6" label="上报领导情况">
        <el-radio-group v-model="ruleForm.reportLeaderFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item class="b1" label="详情">
         <el-input type="textarea" v-model="ruleForm.reportLeaderDetail"></el-input>
      </el-form-item>

      <el-form-item class="a7" label="与家长沟通情况">
        <el-radio-group v-model="ruleForm.parentFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="b2" label="详情">
        <el-input type="textarea" v-model="ruleForm.parentDetail"></el-input>
      </el-form-item>

      <el-form-item label="就医情况">
        <el-radio-group v-model="ruleForm.hospitalFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="医院名称">
        <el-input v-model="ruleForm.hospitalName"></el-input>
      </el-form-item>

      <el-form-item class="a8" label="医院诊断为">
        <el-input type="textarea" v-model="ruleForm.hospitalDetail"></el-input>
      </el-form-item>

      <el-form-item label="服药情况">
        <el-radio-group v-model="ruleForm.medicineFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a9" label="是否在心理中心咨询">
        <el-radio-group v-model="ruleForm.counsultFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a10" label="咨询开始时间年份">
        <el-input v-model="ruleForm.counsultBegin"></el-input>
      </el-form-item>

      <el-form-item label="咨询次数">
        <el-input type="number" v-model="ruleForm.counsultTimes"></el-input>
      </el-form-item>

      <el-form-item class="a11" label="推荐去心理中心">
        <el-radio-group v-model="ruleForm.recommendCounsultFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a12" label="实际是否参与咨询">
        <el-radio-group v-model="ruleForm.realityCounsultFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a13" label="心理联络员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.contactWorkDetail"></el-input>
      </el-form-item>

      <el-form-item class="a14" label="心理委员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.committWorkDetail"></el-input>
      </el-form-item>

      <el-form-item label="对接部门">
        <el-input v-model="ruleForm.contactDeptName"></el-input>
      </el-form-item>

      <el-form-item class="b3" label="为该生">
        <el-input type="textarea" v-model="ruleForm.otherTeacherDetail"></el-input>
      </el-form-item>

      <el-form-item label="多方会商">
        <el-radio-group v-model="ruleForm.multiPartyFlg">
          <el-radio label="1">需要</el-radio>
          <el-radio label="2">不需要</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a15" label="上次谈话后危机状态">
        <span v-if="ruleForm.adjustBefore == '1'" style="color: #FF0808;">红色预警</span>
        <span v-else-if="ruleForm.adjustBefore == '2'" style="color: #A68F52;">橙色预警</span>
        <span v-else-if="ruleForm.adjustBefore == '3'" style="color: #E6A707;">黄色预警</span>
        <span v-else-if="ruleForm.adjustBefore == '4'" style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
        <span v-else-if="ruleForm.adjustBefore == '5'" style="color: rgb(2 158 1);"> 绿色预警</span>
      </el-form-item>

      <!-- <el-form-item class="a16" label="是否调整危机状态">
        <el-radio-group v-model="ruleForm.adjustCrisisFlg">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item class="a17" label="调整后危机状态">
        <el-radio-group v-model="ruleForm.adjustCrisisGrade">
          <el-radio label="1">红色预警</el-radio>
          <el-radio label="2">橙色预警</el-radio>
          <el-radio label="3">黄色预警</el-radio>
          <el-radio label="4">蓝色预警</el-radio>
          <el-radio label="5">绿色预警</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即修改</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userID: '',//学生id
      ruleForm: {
        TalkNo: '',//学生id
        userId:'',//学生id
        realName:'',//学生姓名
        teachID:'',//心理辅导员
        talkTime:'',//2023-01-01T00:00:00.000+08:00", 谈话时间
        talkAddress:'',//谈话地点
        firstCrisisGrade: '',//初评危机状态
        psychCentralSuggests:'',//心理中心建议
        otherSuggest: '',//其他建议
        suicidalFlg: '1',//自杀、自伤或伤害他人倾向
        suicidalDate:'',//自杀、自伤或伤害他人发生时间
        suicidalDetail:'',//自杀、自伤或伤害他人发生情况
        damages:[],//关于伤害的情况
        damageDetail:'',//伤害详细描述
        psychosesFlg:'1',//疑似重性精神病
        psychosesDate:'',//疑似重性精神病发生时间
        psychosesDetail:'',//疑似重性精神病发生情况
        suspectedAppears:[],//疑似出现
        appearDate:'',//疑似出现时间
        appearAddress:'',//疑似出现地点
        appearDetail:'',//疑似出现详情
        reportLeaderFlg:'1',//上报领导情况
        reportLeaderDetail:'',//上报领导详情
        parentFlg:'1',//与家长沟通情况
        parentDetail:'',//与家长沟通详情
        hospitalFlg:'1',//就医情况
        hospitalName:'',//医院名称
        hospitalDetail:'',//就医详情
        counsultFlg:'1',//是否在心理中心咨询
        counsultBegin:'',//在心理中心开始咨询年份
        counsultTimes:'',//在心理中心咨询次数
        recommendCounsultFlg:'1',//是否推荐咨询
        realityCounsultFlg:'1',//实际是否参与咨询
        contactWorkDetail:'',//心理联络员配合工作情况
        committWorkDetail:'',//心理委员配合工作情况
        contactDeptName:'',//对接其他部门名称
        otherTeacherDetail:'',//通过其他部门老师了解情况
        multiPartyFlg: '1',//多方会商是否需要
        adjustBefore: '',//上次谈话后危机状态
        adjustCrisisFlg: '1',//是否调整危机状态
        adjustCrisisGrade: '',//调整后危机状态
        medicineFlg: '1',//服药情况
        status: '',//
        recordStatus: '',//
        updateTime: '',//
        opinion: '',//
        roleID: '',//
        Operate: '1',//
        keyNo:'',
      },
      rules: {
        UserID: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        teachID: [
          { required: true, message: '请输入心理辅导员', trigger: 'blur' },
        ],
        talkTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        talkAddress: [
          { required: true, message: '请输入谈话地点', trigger: 'blur' },
        ],
        firstCrisisGrade: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        psychCentralSuggests: [
          { type: 'array', required: true, message: '请至少选择一个心理中心建议', trigger: 'change' }
        ],
        suicidalFlg:[
          { required: true, message: '请选择自杀、自伤或伤害他人倾向', trigger: 'change' }
        ],
        damages: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
      },
      RoleID: '',
      DeptID: '',
    };

  },
  methods: {
    submitForm(formName) {
      this.ruleForm.keyNo = [this.$route.query.keyNo][0];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('/DistressPrediction/HeartToHeartUpdate', { form: this.ruleForm }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.$router.push({ path: '/Crisis/Crisis_Intervent'});
            } else {
              this.Global.request_failure(res.Message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  mounted() {
    this.RoleID = sessionStorage.getItem('RoleID');
    this.userID = [this.$route.query.UserId][0];
    this.ruleForm.userId = [this.$route.query.UserId][0];
    this.ruleForm.roleID = sessionStorage.getItem('RoleID');
    this.ruleForm.TalkNo = [this.$route.query.TalkNo][0];
    this.$Http_Post('/DistressPrediction/InterviewRecordEcho', { userId: this.userID,type: '2'}).then((res) => {
      if (res.Data) {
        this.ruleForm.userID = res.Data.tuUrgentPreTbl.userId;
        this.ruleForm.realName = res.Data.tuUrgentPreTbl.realName;
        this.ruleForm.teachID = res.Data.tuUrgentPreTbl.teachID;
        this.ruleForm.talkTime = res.Data.tuUrgentPreTbl.appearDate;
        this.ruleForm.talkAddress = res.Data.tuUrgentPreTbl.appearAddress;
        this.ruleForm.psychCentralSuggests = res.Data.tuUrgentPreTbl.psychCentralSuggests;
        this.ruleForm.firstCrisisGrade = res.Data.tuUrgentPreTbl.firstCrisisGrade;
      }
    });

    this.$Http_Post('/DistressPrediction/ToExamineData', { TalkNo: [this.$route.query.TalkNo][0] }).then((res) => {
      if (res.Data) {
        this.ruleForm = {
          userId: res.Data.userId,//学生id
          realName: res.Data.realName,//学生姓名
          teachID: res.Data.teachID,//心理辅导员
          talkTime: res.Data.talkTime,//2023-01-01T00:00:00.000+08:00", 谈话时间
          talkAddress: res.Data.talkAddress,//谈话地点
          firstCrisisGrade: res.Data.firstCrisisGrade,//初评危机状态
          psychCentralSuggests: res.Data.psychCentralSuggests,//心理中心建议
          otherSuggest: res.Data.otherSuggest,//其他建议
          suicidalFlg: String(res.Data.suicidalFlg),//自杀、自伤或伤害他人倾向
          suicidalDate: res.Data.suicidalDate,//自杀、自伤或伤害他人发生时间
          suicidalDetail: res.Data.suicidalDetail,//自杀、自伤或伤害他人发生情况
          damages: res.Data.damages,//关于伤害的情况
          damageDetail: res.Data.damageDetail,//伤害详细描述
          psychosesFlg: String(res.Data.psychosesFlg),//疑似重性精神病
          psychosesDate: res.Data.psychosesDate,//疑似重性精神病发生时间
          psychosesDetail: res.Data.psychosesDetail,//疑似重性精神病发生情况
          suspectedAppears: res.Data.suspectedAppears,//疑似出现
          appearDate: res.Data.appearDate,//疑似出现时间
          appearAddress: res.Data.appearAddress,//疑似出现地点
          appearDetail: res.Data.appearDetail,//疑似出现详情
          reportLeaderFlg: String(res.Data.reportLeaderFlg),//上报领导情况
          reportLeaderDetail: res.Data.reportLeaderDetail,//上报领导详情
          parentFlg: String(res.Data.parentFlg),//与家长沟通情况
          parentDetail: res.Data.parentDetail,//与家长沟通详情
          hospitalFlg: String(res.Data.hospitalFlg),//就医情况
          hospitalName: res.Data.hospitalName,//医院名称
          hospitalDetail: res.Data.hospitalDetail,//就医详情
          counsultFlg: String(res.Data.counsultFlg),//是否在心理中心咨询
          counsultBegin: res.Data.counsultBegin,//在心理中心开始咨询年份
          counsultTimes: res.Data.counsultTimes,//在心理中心咨询次数
          recommendCounsultFlg: String(res.Data.recommendCounsultFlg),//是否推荐咨询
          realityCounsultFlg: String(res.Data.realityCounsultFlg),//实际是否参与咨询
          contactWorkDetail: res.Data.contactWorkDetail,//心理联络员配合工作情况
          committWorkDetail: res.Data.committWorkDetail,//心理委员配合工作情况
          contactDeptName: res.Data.contactDeptName,//对接其他部门名称
          otherTeacherDetail: res.Data.otherTeacherDetail,//通过其他部门老师了解情况
          multiPartyFlg: String(res.Data.multiPartyFlg),//多方会商是否需要
          adjustBefore: res.Data.adjustBefore,//上次谈话后危机状态
          adjustCrisisFlg: String(res.Data.adjustCrisisFlg),//是否调整危机状态
          adjustCrisisGrade: String(res.Data.adjustCrisisGrade),//调整后危机状态
          medicineFlg: String(res.Data.medicineFlg),//服药情况
          status: '', //
          recordStatus: '', //
          updateTime: '', //
          opinion: '', //
          roleID: sessionStorage.getItem('RoleID'), //
          Operate: '1', //
          talkNo:[this.$route.query.TalkNo][0]
        }
      }
    });
  },
  filters: {
    // dateFormat(datetime) {
    //   var dt = new Date(datetime);
    //   var y = dt.getFullYear();
    //   var M = dt.getMonth() + 1;
    //   var d = dt.getDate();
    //   var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
    //   var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
    //   var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds();
    //   return `${y}-${M}-${d} ${h}:${m}:${s}`;
    // },
  },
};
</script>
<style>
.MemconForm  {width: 100%;background-color: #fff;}
.MemconForm .el-form-item__content .el-input  {width: 300px;}
.MemconForm .a1 .el-form-item__content .el-checkbox-group  {width: 850px;}
.MemconForm .a1 .el-form-item__label  {width: 130px !important;}
.MemconForm .a2 .el-form-item__label  {width: 330px !important;}
.MemconForm .a3 .el-form-item__label  {width: 138px !important;}
.MemconForm .a4 .el-form-item__label  {width: 155px !important;}
.MemconForm .a5 .el-form-item__label  {width: 100px !important;}
.MemconForm .a6 .el-form-item__label  {width: 120px !important;}
.MemconForm .a7 .el-form-item__label  {width: 140px !important;}
.MemconForm .a8 .el-form-item__label  {width: 114px !important;}
.MemconForm .a8 .el-textarea  {width: 500px !important;}
.MemconForm .b1 .el-textarea  {width: 500px !important;}
.MemconForm .b2 .el-textarea  {width: 500px !important;}
.MemconForm .b3 .el-textarea  {width: 500px !important;}

.MemconForm .a9 .el-form-item__label  {width: 167px !important;}
.MemconForm .a10 .el-form-item__label  {width: 154px !important;}
.MemconForm .a10 .el-textarea  {width: 500px !important;}
.MemconForm .a11 .el-form-item__label  {width: 140px !important;}
.MemconForm .a12 .el-form-item__label  {width: 154px !important;}

.MemconForm .a13 .el-form-item__label  {width: 196px !important;}
.MemconForm .a13 .el-textarea  {width: 500px !important;}
.MemconForm .a14 .el-form-item__label  {width: 184px !important;}
.MemconForm .a14 .el-textarea  {width: 500px !important;}

.MemconForm .a15 .el-form-item__label  {width: 170px !important;}
.MemconForm .a16 .el-form-item__label  {width: 156px !important;}
.MemconForm .a17 .el-form-item__label  {width: 140px !important;}

</style>
